import { render, staticRenderFns } from "./MediaListItemCoverAction.vue?vue&type=template&id=65e9b893"
import script from "./MediaListItemCoverAction.vue?vue&type=script&lang=js"
export * from "./MediaListItemCoverAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports